@if (state$ | async; as state) {
  @if (data?.total_items) {
    @for (manager of data.items | slice: 0:4; track manager.id) {
      <div class="list-item club" (click)="openLink(['/', 'syndicates','manager',manager.id])">
        <div class="list-item-avatar-holder">
          <img [alt]="manager.username" 
               #el 
               class="feature-avatar" 
               imgLazyLoad 
               [src]="manager.picture_url" 
               (error)="setFallbackImage(manager); el.src = fallbackMangerImage" />
          @if (getSyndicateCounter(manager, state.sportCategoryId) > 0) {
            <div class="tag">
              <div class="counter">{{getSyndicateCounter(manager, state.sportCategoryId)}}</div>
            </div>
          }
        </div>
        <div class="club-member center-align">
          <div class="captain-name">
            <span>{{manager.username}}</span>
          </div>
          <div class="tertiary-info">
            {{manager.followers_number}} <span [transloco]="'profile.FOLLOWERS'"></span>
          </div>
        </div>
      </div>
    }
  }
}